module.exports = __webpack_public_path__ + "static/media/close.b3a0314e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = 1208
// module chunks = 0